import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

const DrawerButton = (props) => {

  const {toggleDrawer, menuButton} = props;

  return (
    <IconButton
        className={menuButton}
        color="inherit"
        aria-label="open drawer"
        onClick={toggleDrawer(true)}>
         <MenuIcon />
      </IconButton>
  )
}

export default DrawerButton;






// WEBPACK FOOTER //
// ./src/components/Header/DrawerButton.js